<template>
    <div class="wrap">
        <h3 class="wrap-title reveal-bottom">{{ $t("sp.f_title") }}</h3>
        <p class="wrap-text reveal-bottom">
            {{ $t("sp.f_subTitle") }}
        </p>
        <div class="form">
            <div class="form-item">
                <span class="label">{{ $t("sp.f_first") }} *</span>
                <input class="inp" v-model="firstName" type="text" />
            </div>
            <div class="form-item">
                <span class="label">{{ $t("sp.f_last") }} *</span>
                <input class="inp" v-model="lastName" type="text" />
            </div>
            <div class="form-item">
                <span class="label">{{ $t("sp.f_email") }} *</span>
                <input class="inp" v-model="email" type="text" />
            </div>
            <div class="form-item">
                <span class="label">{{ $t("sp.f_com") }} *</span>
                <input class="inp" v-model="companyName" type="text" />
            </div>
            <div class="form-item">
                <span class="label ">{{ $t("sp.f_region") }} *</span>
                <select class="inp" v-model="countryId">
                    <option
                        v-for="item in countryList"
                        :key="item.id"
                        :value="item.id"
                        >{{ item.name }}</option
                    >
                </select>
            </div>
            <div class="form-item">
                <span class="label">{{ $t("sp.f_tel") }} *</span>
                <input class="inp" v-model="phone" type="number" />
            </div>
            <div class="form-item" style="width:580px">
                <p class="label">{{ $t("sp.f_other") }}</p>
                <div>
                    <div class="input-radio">
                        <input
                            id="yes"
                            type="radio"
                            name="radio-box"
                            value="1"
                            v-model="checked"
                        />
                        <label for="yes">{{ $t("sp.f_yes") }}</label>
                    </div>
                    <div class="input-radio">
                        <input
                            id="no"
                            type="radio"
                            name="radio-box"
                            value="0"
                            v-model="checked"
                        />
                        <label for="no">{{ $t("sp.f_not") }}</label>
                    </div>
                    <div class="input-radio">
                        <input
                            id="more"
                            type="radio"
                            name="radio-box"
                            v-model="checked"
                        />
                        <label for="more">{{ $t("sp.f_more") }}</label>
                    </div>
                </div>
                <div>
                    <textarea
                        class="text-area"
                        name="context"
                        id=""
                        v-model="remark"
                    ></textarea>
                </div>
            </div>
        </div>
        <div style="overflow:hidden">
            <div class="submit" @click="submit">{{ $t("sp.f_submit") }}</div>
        </div>
    </div>
</template>
<script>
import axios from "@/http";

export default {
    data() {
        return {
            firstName: "",
            lastName: "",
            email: "",
            companyName: "",
            countryId: 80,
            phone: "",
            remark: "",
            countryList: [],
            checked: null,
        };
    },
    computed: {
        anyProblem: function() {
            return Boolean(Number(this.checked));
        },
    },
    created() {
        this.getCountry();
    },
    methods: {
        submit: function() {
            //校验
            if (!this.firstName) {
                this.$message({
                    message: "名不能为空",
                    type: "warning",
                    offset: 80,
                });
                return;
            }
            if (!this.lastName) {
                this.$message({
                    message: "姓不能为空",
                    type: "warning",
                    offset: 80,
                });
                return;
            }
            if (!this.email) {
                this.$message({
                    message: "Email不能为空",
                    type: "warning",
                    offset: 80,
                });
                return;
            }
            if (!this.companyName) {
                this.$message({
                    message: "公司名称不能为空",
                    type: "warning",
                    offset: 80,
                });
                return;
            }
            if (!this.phone) {
                this.$message({
                    message: "phone不能为空",
                    type: "warning",
                    offset: 80,
                });
                return;
            }
            this.form();
        },
        form: async function() {
            const res = await axios.put("/api2/apply", {
                anyProblem: this.anyProblem,
                companyName: this.companyName,
                countryId: this.countryId,
                email: this.email,
                firstName: this.firstName,
                lastName: this.lastName,
                phone: this.phone,
                remark: this.remark,
            });
            if (res.code === 0) {
                this.$alert(
                    `OceanBlue Cloud向您的邮箱发送了一封邮件,请登录邮箱确认! ( ${this.email})`,
                    "Success",
                    {
                        confirmButtonText: "确定",
                        callback: (action) => {
                            this.$message({
                                message: "Success",
                                type: "success",
                                offset: 80,
                            });
                        },
                    }
                );
                //初始化
                this.firstName = "";
                this.lastName = "";
                this.email = "";
                this.companyName = "";
                this.phone = "";
                this.remark = "";
                this.checked = null;
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                    offset: 80,
                });
            }
            console.log(res);
        },
        getCountry: async function() {
            const res = await axios.get("/api2/country/names");
            if (res.code === 0) {
                this.countryList = res.data;
            }
        },
    },
};
</script>
<style scoped>
.wrap {
    width: 1200px;
    margin: auto;
}
.wrap-title {
    margin-top: 100px;
    font-size: 44px;
    color: #000000;
    font-weight: bold;
    line-height: 66px;
}
.wrap-text {
    font-size: 22px;
    color: #333333;
    letter-spacing: 0;
    line-height: 44px;
    margin-top: 20px;
    margin-bottom: 75px;
}
.form {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.form-item {
    width: 270px;
    margin-top: 50px;
}
.inp {
    width: 100%;
    height: 50px;
    line-height: 50px;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    background: #ffffff;
    outline: none;
    font-size: 16px;
    color: rgba(51, 51, 51, 0.5);
    letter-spacing: 0;
    vertical-align: middle;
}
.inp:focus {
    border-bottom: 1px solid #00a3d1;
    color: rgba(51, 51, 51, 0.8);
}
.label {
    display: inline-block;
    line-height: 22px;
    font-size: 16px;
    color: rgba(51, 51, 51, 0.5);
    letter-spacing: 0;
}
.input-radio {
    margin: 1em 5px;
    display: inline-block;
}
.input-radio input[type="radio"] {
    opacity: 0;
}
.input-radio input[type="radio"] + label {
    position: relative;
    cursor: pointer;
}
.input-radio input[type="radio"] + label::before {
    content: "";
    position: absolute;
    left: -24px;
    top: -5px;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    border: 1px solid #999;
}
.input-radio input[type="radio"] + label::after {
    content: "";
    position: absolute;
    left: -20px;
    top: -1px;
    border-radius: 50%;
    width: 12px;
    height: 12px;
}
.input-radio input[type="radio"]:checked + label::before {
    border: 1px solid #00a3d1;
    box-shadow: 0 0 6px #00a3d1;
    transition: all 0.3s;
}
.input-radio input[type="radio"]:checked + label::after {
    background: #00a3d1;
    transition: all 0.5s;
}
.text-area {
    width: 300px;
    height: 50px;
    border: 1px solid rgba(0, 0, 0, 0.1);
}
.text-area:focus {
    border: 1px solid #00a3d1;
    outline: none;
}
.submit {
    width: 200px;
    height: 50px;
    background: #00a3d1;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    line-height: 50px;
    font-weight: bold;
    cursor: pointer;
    margin-top: 50px;
    margin-bottom: 100px;
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Support/Form.vue